import { Injectable } from '@angular/core';
import { DefaultSelect } from '@documalis/_const/const';

@Injectable()
export class DynIndexService {
    public changeDyn = false;
    public varListAll: Array<any>;
    public customEditorList: any;

    constructor() {
        this.varListAll = new Array();
    }

    public setCustomEditorList(aEditorList) {
        this.customEditorList = aEditorList;
    }

    public reset() {
        this.varListAll = [];
        this.setChangeDyn(false);
    }

    public setChangeDyn(aValue) {
        this.changeDyn = aValue;
    }

    public getChangeDyn() {
        return this.changeDyn;
    }

    public changeDynIndex(aVarList, item, index) {
        let wVarList = new Array();
        let wOldValue = '';
        let wNewValue = '';
        let wCurrentDynValue = '';
        this.setChangeDyn(true);

        wCurrentDynValue = this.getCurentDynValue(index);
        if (wCurrentDynValue !== '') {
            wOldValue = item.childPath + wCurrentDynValue;
        } else {
            wOldValue = item.childPath + item.DefaultValue;
        }

        if (item.value.retCode === null) {
            wNewValue = item.childPath;
        } else {
            wNewValue = item.childPath + item.value.retCode;
        }

        // console.log('changeDynIndex', this.varListAll);
        this.resetDynValue(item.refIndex);
        // console.log('changeDynIndex af', this.varListAll);
        this.varListAll[item.refIndex].value = item.value;

        this.activate(wOldValue, wNewValue);

        wVarList = this.loadActivField();
        return wVarList;
    }

    private getCurentDynValue(aIndex) {
        let wValue = '';
        if (this.varListAll[aIndex].currentDynValue) {
            if (this.varListAll[aIndex].currentDynValue !== '') {
                wValue = this.varListAll[aIndex].currentDynValue;
            }
        }
        return wValue;
    }

    private resetDynValue(aIndex) {
        let wOption = [];
        for (let i = aIndex + 1; i < this.varListAll.length; i++) {
            if (this.varListAll[i].type === 'DynamicIndex' && this.varListAll[i].isActiv === true) {
                if (this.varListAll[i].DefaultValue === '') {
                    // Mémorisation des options pour réaffectaion (la variable value pointe
                    // sur comboValue, raz de l'un = raz de l'autre)
                    wOption = [];
                    wOption = this.memOption(this.varListAll[i].comboValue);
                    this.varListAll[i].value = {
                        displayValue: DefaultSelect,
                        retCode: null,
                    };
                    this.varListAll[i].comboValue = wOption;
                }
            }
        }
    }

    private activate(aOldValue, aNewValue) {
        let wPath = '';
        let wPatht = '';
        if (aOldValue !== '') {
            for (let i = 0; i < this.varListAll.length; i++) {
                wPath = this.varListAll[i].path;
                wPatht = this.varListAll[i].path.substring(0, aOldValue.length);
                if (wPatht === aOldValue) {
                    this.varListAll[i].isActiv = false;
                }
            }
        }
        // console.log('activate af', this.varListAll);
        for (let i = 0; i < this.varListAll.length; i++) {
            if (this.varListAll[i].path === aNewValue) {
                this.varListAll[i].isActiv = true;
                if (this.varListAll[i].type === 'DynamicIndex') {
                    this.updateActivate(i, aNewValue, this.varListAll[i].dynName);
                }
            }
        }
    }

    private updateActivate(aIndex, aNewValue, aDynName) {
        // console.log('updateActivate', aIndex, aNewValue, aDynName);
        let wValueList;
        let wName = '';
        let wValue = '';
        if (aDynName !== '') {
            wValueList = this.getValueListFromCustomEditor(aDynName);
            for (let k = 0; k < wValueList.Value.length; k++) {
                wName = wValueList.Value[k].Name;
                if (this.varListAll[aIndex].value.retCode !== '') {
                    wValue = this.varListAll[aIndex].value.retCode;
                } else {
                    wValue = this.varListAll[aIndex].DefaultValue;
                }
                if (wValue === wName) {
                    for (let i = aIndex + 1; i < this.varListAll.length; i++) {
                        let wVar = this.varListAll[i].path;
                        let wVal = aNewValue + '/' + this.varListAll[aIndex].name + '=' + wName;
                        if (this.varListAll[i].path === aNewValue + '/' + this.varListAll[aIndex].name + '=' + wName) {
                            this.varListAll[i].isActiv = true;
                            this.updateActivate(i, this.varListAll[i].path, this.varListAll[i].dynName);
                        }
                    }
                }
            }
        }
    }

    public activateAll() {
        let wOldValue = '';
        let wNewValue = '';
        for (let item of this.varListAll) {
            if (item.isActiv === true) {
                if (item.type === 'DynamicIndex') {
                    if (item.value.retCode !== '') {
                        if (item.value.retCode !== item.DefaultValue) {
                            wOldValue = item.childPath + item.DefaultValue;
                            wNewValue = item.childPath + item.value.retCode;
                            this.activate(wOldValue, wNewValue);
                        }
                    }
                }
            }
        }
    }

    public loadActivField() {
        // console.log(aVarListAll)
        let wVarList = new Array();
        wVarList = [];
        for (let i = 0; i < this.varListAll.length; i++) {
            if (this.varListAll[i].isActiv === true) {
                var item = this.varListAll[i];
                item.refIndex = i;
                wVarList.push(item);
            }
        }
        return wVarList;
    }

    public setCurrentValue(aValue, index) {
        this.varListAll[index].currentDynValue = aValue;
    }

    private memOption(aData) {
        let wOption = [];
        let wItem: any;
        for (const item of aData) {
            wItem = new Object();
            wItem.displayValue = item.displayValue;
            wItem.retCode = item.retCode;
            wOption.push(wItem);
        }
        return wOption;
    }

    private getValueListFromCustomEditor(aName) {
        let wResult: any;
        for (const item of this.customEditorList.CustomEditor) {
            if (item.Information.Name === aName) {
                if (item.DynamicIndex.ValueList) {
                    wResult = item.DynamicIndex.ValueList;
                }
                break;
            }
        }
        return wResult;
    }
}
